import { hydrateWidgets } from '@utils';
import { Feedback } from '../../widgets/Explore/DVWebNodeFeedback';
hydrateWidgets(Feedback);
